import UnSupportImagePreview from './UnSupportImagePreview';
import './style/index.less';

export default UnSupportImagePreview;
